import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/subscription/mutations'
import { ISubscriptionState, initialState } from '@/store/modules/subscription/state'

export * from '@/store/modules/subscription/state'

export const store: Module<ISubscriptionState, RootState> = {
  state: initialState,
  mutations
}
